import { useCallback, useEffect, useState } from "react";
import { api, errText, newKey } from "@/lib/api";

export default function PhotoPilot() {
  const [data,setData]=useState(null),[error,setError]=useState(""),[accepted,setAccepted]=useState(false),[busy,setBusy]=useState(false);
  const [key]=useState(newKey);
  const refresh=useCallback(async()=>{try{setData((await api.get("/admin/photo-pilot")).data);setError("");}catch(e){setError(errText(e));}},[]);
  useEffect(()=>{refresh();},[refresh]);
  const generate=async()=>{
    if(!data?.enabled||!data?.readiness?.ready||data.request||!accepted)return;
    setBusy(true);
    try{setData((await api.post("/admin/photo-pilot",{request_key:key,context_hash:data.context_hash,accept_estimate:true,max_authorized_usd:1})).data);setError("");}
    catch(e){setError(errText(e));await refresh();}
    finally{setBusy(false);}
  };
  return <section className="border border-border rounded-xl p-5 space-y-4" aria-label="Internal photo pilot">
    <h2 className="font-display text-2xl">One sponsored photo</h2>
    {error&&<p role="alert">{error}</p>}
    {data&&<>
      <p>One medium 1024 × 1024 photo from the internal workspace’s Legacy Persona. No customer credits.</p>
      {!data.enabled&&<p role="status">Disabled pending the specific test approval.</p>}
      {!data.readiness.ready&&<p role="status">{data.readiness.message}</p>}
      {data.prompt&&<details><summary>Review the exact business-persona photo brief</summary><pre className="whitespace-pre-wrap text-xs mt-3">{data.prompt}</pre></details>}
      {data.request?<><p role="status">Request: {data.request.state}. No automatic retry.</p><pre aria-label="Photo attempt receipt" className="whitespace-pre-wrap text-xs">{JSON.stringify(data.request,null,2)}</pre><a href="/library" className="underline">Open workspace Library</a></>:<>
        <label className="flex gap-3"><input type="checkbox" checked={accepted} onChange={e=>setAccepted(e.target.checked)} />I approve one OpenAI request with a $1 spending authorization. Expected cost is about 5–8 cents; the API has no hard-dollar cutoff. No retries.</label>
        <button type="button" className="btn-gold" disabled={busy||!accepted||!data.enabled||!data.readiness.ready} onClick={generate}>Generate one sponsored photo</button>
      </>}
    </>}
    <button type="button" className="btn-outline block" disabled={busy} onClick={refresh}>Refresh photo status</button>
  </section>;
}
